import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    margin: '24px auto 40px auto',
    maxWidth: ({isAllocationProcess}: {isAllocationProcess: boolean}) => isAllocationProcess ? theme.space.allocationProcessMaxWidth : theme.space.singleColumnMaxWidth,
    [theme.breakpoints.down('xs')]: {
      margin: `16px -${theme.space.appPadding}px 40px`,
      padding: `24px ${theme.space.appPadding}px 24px`,
      borderRadius: 0,
    },
  }
}), { name: 'ProcessCard', index: StylesIndexInjections.OTHER });
